export default "__VITE_ASSET__0ec5fc7d__"